<div>
  <mwp-card-content-header [url]="apiUrl" />
  @if (!isEditing && payrollAddressModel) {
    <div>
      <mwp-payroll-address-form title="Current Address" [payrollAddressModel]="payrollAddressModel" [isEditing]="isEditing" />
      @if (displayTopRequestButton) {
        <div class="d-flex justify-content-end mb-3">
          <button class="mwp-button" (click)="newChangeRequest()">
            <mwp-text-translate [text]="buttonText" [jsonKey]="buttonText" />
          </button>
        </div>
      }
      @if (displayPendingOrDeniedRequest) {
        <div class="mb-3">
          <mwp-payroll-address-form [title]="pendingOrDeniedHeader" [ChangeRequestAddressModel]="currentChangeRequestAddressModel" [isEditing]="isEditing" />
        </div>
      }
      @if (!displayTopRequestButton) {
        <div class="d-flex justify-content-end">
          <button class="mwp-button" (click)="editChangeRequest()">
            <mwp-text-translate [text]="buttonText" [jsonKey]="buttonText" />
          </button>
        </div>
      }
    </div>
  }
  @if (isEditing) {
    <div>
      <mwp-payroll-address-form title="New Change Request" [payrollAddressModel]="payrollAddressModel" [ChangeRequestAddressModel]="changeRequestFormModel" [isEditing]="isEditing" (cancelEmit)="cancelEdit($event)"/>
    </div>
  }
</div>